import React from "react";

function Application() {
  return (
    <div className=" default-padding-top blurry-shape-top-full">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-7">
            <div
              className="about-style-one-info bg-gray fade-up-anim"
              style={{ backgroundImage: "url(assets/img/illustration/4.png)" }}
            >
              <h2 className="fixed-text">XEER TECHNOLOGY</h2>
              <h4 className="sub-title">About Xeer Technology</h4>
              <h2 className="title split-lines">
                Unlock Limitless Possibilities with Intelligent Solutions
              </h2>
              <p>
                At Xeer Technology — Blockchain & AI Builders, we help
                businesses transform ideas into scalable digital products using
                AI, Blockchain, and modern software systems.
              </p>
              <p>
                As a trusted blockchain development company in India, we deliver
                secure, scalable, and future-ready solutions for startups,
                enterprises, and growing businesses worldwide.
              </p>
              <p>
                From smart contracts and crypto exchange platforms to AI agents
                and enterprise software, our team provides end-to-end execution
                built for performance, security, and long-term growth.
              </p>
              <div className="flex flex-wrap gap-4 mt-8">
                <div className="px-5 py-3 bg-white/10 border border-white/20 rounded-xl backdrop-blur-md text-sm">
                  One Team. Complete Execution. Built to Scale.
                </div>
                <div className="px-5 py-3 bg-indigo-500/20 border border-indigo-400/30 rounded-xl backdrop-blur-md text-sm">
                  Backed by 8+ years of experience delivering real-world digital
                  solutions globally.
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-5">
            <div className="card-style-one-item fade-up-anim bg-gradient text-light">
              <img
                src="assets/img/shape/api_integration.png"
                alt="Image Not Found"
              />
              <div className="info">
                <h3 className="sub-title-one">Driven by Innovation</h3>
                <p>
                  We leverage cutting-edge technologies like AI, Blockchain, and
                  automation to build intelligent systems that improve
                  efficiency, enhance decision-making, and unlock new growth
                  opportunities
                </p>
                <div className="text-end mt-40"></div>
              </div>
            </div>
            <div className="card-style-one-two fade-up-anim mt-30">
              <h4 className="sub-title-one pb-3">Built for Scalability</h4>
              <p>
                Every solution we develop is designed to be secure,
                high-performance, and scalable — helping businesses adapt, grow,
                and succeed in rapidly evolving digital markets
              </p>
              <p>
                From AI automation to crypto exchange and token development, we
                build technology designed for the future.
              </p>
              {/* <div className="bottom">
                <img
                  src="assets/img/thumb/seamless_integration.png"
                  alt="Image Not Found"
                />
         
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Application;
